"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _validator = _interopRequireDefault(require("./validator"));
var _events = _interopRequireDefault(require("./events"));
var _types = _interopRequireDefault(require("./types.json"));
var _handleError = _interopRequireDefault(require("../sentry/handleError"));
var _errors = _interopRequireDefault(require("../sentry/errors.json"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var reportToSegment = function reportToSegment(type, id) {
  var properties = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var element = arguments.length > 4 ? arguments[4] : undefined;
  if (!window.analytics) {
    return;
  }
  switch (type) {
    case _types["default"].PAGE:
      window.analytics.page(id);
      break;
    case _types["default"].IDENTIFY:
      if (id) {
        window.analytics.identify(id, properties);
      } else {
        (0, _handleError["default"])(_errors["default"].segmentIdentityIdMissing);
      }
      break;
    case _types["default"].ALIAS:
      if (id) {
        window.analytics.alias(id);
      } else {
        (0, _handleError["default"])(_errors["default"].segmentAliasIdMissing);
      }
      break;
    case _types["default"].RESET:
      window.analytics.reset();
      break;
    // trackForm is used in oem-auth to provide a 300ms delay before form submission to allow for tracking calls to finish before the page redirect
    // https://segment.com/docs/connections/sources/catalog/libraries/website/javascript/#track-form
    case _types["default"].FORM:
      if (element.tagName !== 'FORM') {
        (0, _handleError["default"])(_errors["default"].segmentElementTypeInvalid, element.tagName);
      } else if ((0, _validator["default"])(id, properties)) {
        window.analytics.trackForm(element, _events["default"][id].eventName, properties, options);
      }
      break;
    case _types["default"].TRACK:
      if ((0, _validator["default"])(id, properties)) {
        window.analytics.track(_events["default"][id].eventName, properties, options);
      }
      break;
    case _types["default"].GROUP:
      if (id) {
        window.analytics.group(id, properties);
      } else {
        (0, _handleError["default"])(_errors["default"].segmentGroupIdMissing);
      }
      break;
    default:
      (0, _handleError["default"])(_errors["default"].segmentTypeInvalid);
  }
};
var _default = reportToSegment;
exports["default"] = _default;